// StandardSummary.jsx

import {
  Stack,
  Typography,
  IconButton,
} from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

const StandardSummary = ({
  quantity,
  unitPrice,
  subtotal,
  gatewayCharge,
  total,
  currencySymbol,
  onAdd,
  onReduce,
}) => {
  return (
    <Stack component="section" spacing={1} sx={{ padding: "20px" }}>
      {/* Quantity */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize="12pt">Service Quantity</Typography>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <IconButton size="small" onClick={onReduce} color="error">
            <RemoveCircleOutline sx={{ fontSize: "18pt" }} />
          </IconButton>
          <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
              width: "40px",
              height: "40px",
              border: "2px solid gray",
              borderRadius: "12px",
            }}
          >
            {quantity}
          </Stack>
          <IconButton size="small" onClick={onAdd} color="success">
            <AddCircleOutline sx={{ fontSize: "18pt" }} />
          </IconButton>
        </Stack>
      </Stack>

      {/* Pricing Details */}
      {[
        { label: "Net Price", value: unitPrice },
        { label: "Subtotal", value: subtotal },
        { label: "Gateway Charge", value: gatewayCharge },
        { label: "Total Amount", value: total },
      ].map((item, i) => (
        <Stack
          key={i}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography fontSize="12pt">{item.label}</Typography>
          <Typography fontSize="12pt" fontWeight={600} pr="40px">
            {currencySymbol} {item.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default StandardSummary;
